import { Base } from '@studiometa/js-toolkit';
import { addClass, removeClass } from '@studiometa/js-toolkit/utils';

/**
 * Homepage class.
 */
export default class HeroVideo extends Base {
  /**
   * Class config
   * @type {object}
   */
  static config = {
    name: 'HeroVideo',
    refs: ['video', 'source', 'poster'],
  };

  /** @inheritdoc */
  mounted() {
    this.$refs.source.src = this.$refs.source.dataset.src;

    // Play video
    this.$refs.video.pause();
    this.$refs.video.load();
    this.$refs.video.play();

    // Show video
    removeClass(this.$refs.video, 'opacity-0 pointer-events-none');

    // Hide poster
    addClass(this.$refs.poster, '!opacity-0');
  }
}
